module.exports = __webpack_public_path__ + "img/itx-file-type-image.1d49d7fe.svg";